import {NAME} from './constants';

export const getUsers = state => state[NAME].list;
export const areUsersValid = state => state[NAME].valid;
export const getSelectedUser = state => state[NAME].selected.user;
export const getSelectedPermissions = state => state[NAME].selected.permissions;


/** WEBPACK FOOTER **
 ** ./src/modules/users/selectors.js
 **/